import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Caption, Card, PageHeader, Spinner } from "@/components/Common";
import { Rich } from "@/components/Rich";
import { api, errMsg } from "@/lib/api";

export default function Referrals() {
  const [data, setData] = useState(null);
  const [code, setCode] = useState("");
  const load = () => api.get("/referrals").then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const claim = async (e) => {
    e.preventDefault();
    try { const { data: d } = await api.post("/referrals/claim", { code: code.trim() }); toast.success(d?.message || "Code claimed"); setCode(""); load(); } catch (e2) { toast.error(errMsg(e2)); }
  };
  if (!data) return <Spinner className="h-6 w-6 text-[#D4AF37]" />;
  const link = `${window.location.origin}/login?ref=${data.code}`;
  const { code: _c, count, ...rest } = data;
  const copy = (t) => { navigator.clipboard.writeText(t); toast.success("Copied"); };
  return (
    <div>
      <PageHeader title="Referrals" subtitle="Invite friends to RPOPRO. Works across the app and the web." />
      <div className="grid gap-6 lg:grid-cols-2">
        <Card className="border-[#D4AF37]/30">
          <Gift className="mb-4 h-6 w-6 text-[#D4AF37]" />
          <Caption>Your code</Caption>
          <div className="mt-2 flex items-center gap-3"><span className="font-mono text-3xl tracking-widest text-[#F3C649]" data-testid="referral-code">{data.code}</span>
            <Button size="icon" variant="outline" onClick={() => copy(data.code)} data-testid="copy-referral-code"><Copy className="h-4 w-4" /></Button></div>
          <div className="mt-5 flex gap-2"><Input readOnly value={link} className="bg-[#09090B] font-mono text-xs" /><Button variant="outline" onClick={() => copy(link)} data-testid="copy-referral-link">Copy link</Button></div>
          <div className="mt-6 font-display text-4xl text-zinc-100" data-testid="referral-count">{count ?? 0}<span className="ml-2 text-sm text-zinc-500">friends joined</span></div>
          {Object.keys(rest).length > 0 && <div className="mt-6"><Rich value={rest} /></div>}
        </Card>
        <Card className="h-fit">
          <h3 className="font-display text-lg text-zinc-100">Got a code?</h3>
          <form onSubmit={claim} className="mt-4 flex gap-2">
            <Input value={code} onChange={(e) => setCode(e.target.value)} placeholder="Enter referral code" className="bg-[#09090B] font-mono uppercase" required data-testid="claim-code-input" />
            <Button type="submit" data-testid="claim-code-button">Claim</Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
